import { ajax } from "@/plugins/ajax";

export default {
  namespaced: true,
  state: {
    partnerIndividuals: []
  },
  getters: {
    GetpartnerIndividuals: state => state.partnerIndividuals
  },
  mutations: {
    setAgentRecipientsIndividuals(state, data) {
      state.partnerIndividuals = data;
    }
  },
  actions: {
    fetchAgentRecipientsIndividuals({ commit }) {
      return new Promise((resolve, reject) => {
        ajax
          .post("/BussinessParties/api/partnerIndividuals")
          .then(r => {
            commit("setAgentRecipientsIndividuals", r.data);
            resolve(r.data);
          })
          .catch(e => reject(e));
      });
    }
  }
};
